type isSelectedServiceProps = {
  services: any
  selectedService: string
}

const isSelectedService = ({
  services,
  selectedService,
}: isSelectedServiceProps) => {
  return services.find((i: any) =>
    i.serviceTypeName.includes(String(selectedService)),
  )
}

export default isSelectedService
